import { render, staticRenderFns } from "./emailRelationalDataTableConfig.vue?vue&type=template&id=d96a7a10&scoped=true"
import script from "./emailRelationalDataTableConfig.vue?vue&type=script&lang=js"
export * from "./emailRelationalDataTableConfig.vue?vue&type=script&lang=js"
import style0 from "./emailRelationalDataTableConfig.vue?vue&type=style&index=0&id=d96a7a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96a7a10",
  null
  
)

export default component.exports